import { ConfirmOptions } from "material-ui-confirm";

export const defaultConfirmOptions: ConfirmOptions = {
	confirmationButtonProps: { variant: "contained" },
	cancellationButtonProps: { variant: "text" },
	dialogActionsProps: { sx: { padding: "20px 45px" } },
};
